import React from 'react';
import { Modal } from '../../components';
import { createResourceLocatorString } from '../../util/routes';

import css from './ListingPage.module.css';
import LeadFeeRequestForm from './LeadFeeRequestForm/LeadFeeRequestForm';

const LeadFeeRequestModal = props => {
  const {
    location,
    history,
    routes,
    isAuthenticated,
    author,
    authorDisplayName,
    leadFeeRequestInProgress,
    leadFeeRequestError,
    leadFeeRequestModalOpen,
    setLeadFeeRequestModalOpen,
    onSubmitLeadFeeRequest,
    onManageDisableScrolling,
    deliveryMethod,
    customerFullName,
    productName,
    // Prefilled message body — the ready-mix order panel's specification, quantity,
    // site and date, so the seller receives the order and not a blank request.
    initialMessage,
  } = props;

  const handleCloseModal = () => {
    setLeadFeeRequestModalOpen(false);

    if (location.state?.leadFeeRequestModalOpen) {
      const to = createResourceLocatorString('CartPage', routes);
      history.push(to);
    }
  };

  return (
    <Modal
      id="ListingPage.leadFeeRequestModal"
      containerClassName={css.requestPriceModalContainer}
      isOpen={isAuthenticated && leadFeeRequestModalOpen}
      onClose={handleCloseModal}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <LeadFeeRequestForm
        key={leadFeeRequestModalOpen}
        className={css.requestPriceForm}
        author={author}
        productDisplayName={productName}
        onSubmit={(values) => onSubmitLeadFeeRequest(values, deliveryMethod, customerFullName)}
        initialValues={initialMessage ? { message: initialMessage } : undefined}
        inProgress={leadFeeRequestInProgress}
        leadFeeRequestError={leadFeeRequestError}
      />
    </Modal>
  );
};

export default LeadFeeRequestModal;
